// XML Parser für DAT/VXS Fahrzeugdaten
export const parseVehicleXML = (xmlString) => {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xmlString, "text/xml");
  
  // Helper function to get text content from tag
  const getText = (tagName, parent = xmlDoc) => {
    const el = parent.getElementsByTagNameNS("*", tagName)[0];
    return el ? el.textContent.trim() : "";
  };
  
  // Helper to get all elements with namespace
  const getAll = (tagName, parent = xmlDoc) => {
    return Array.from(parent.getElementsByTagNameNS("*", tagName));
  };

  // Extrahiere Marke
  const brand = getText("ManufacturerName") || "Unbekannt";
  
  // Extrahiere Modell
  let model = getText("BaseModelName");
  // Bereinige Modellname (entferne Datumsangaben in Klammern)
  if (model) {
    model = model.replace(/\([^)]*\)/g, "").trim();
  }
  const subModel = getText("SubModelName");
  if (subModel && !model.includes(subModel)) {
    model = `${model} ${subModel}`.trim();
  }
  
  // Extrahiere Jahr aus Erstzulassung
  const initialReg = getText("InitialRegistration");
  let year = "";
  if (initialReg) {
    const match = initialReg.match(/(\d{4})/);
    if (match) year = match[1];
  }
  
  // Kilometerstand
  const mileage = getText("MileageOdometer");
  
  // Farbe
  const color = getText("Color") || "Unbekannt";
  
  // Motor-Info extrahieren
  let engine = "";
  let power = "";
  let fuel = "";
  
  const equipmentPositions = getAll("EquipmentPosition");
  for (const pos of equipmentPositions) {
    const desc = getText("Description", pos);
    if (desc.toLowerCase().includes("motor") && desc.includes("kW")) {
      engine = desc;
      // Extrahiere kW
      const kwMatch = desc.match(/(\d+)\s*kW/);
      if (kwMatch) power = `${kwMatch[1]} kW`;
      // Bestimme Kraftstoff
      if (desc.toLowerCase().includes("tdi") || desc.toLowerCase().includes("diesel")) {
        fuel = "Diesel";
      } else if (desc.toLowerCase().includes("tsi") || desc.toLowerCase().includes("benzin")) {
        fuel = "Benzin";
      } else if (desc.toLowerCase().includes("elektro") || desc.toLowerCase().includes("ev")) {
        fuel = "Elektro";
      } else if (desc.toLowerCase().includes("hybrid")) {
        fuel = "Hybrid";
      }
      break;
    }
  }
  
  // Getriebe
  let transmission = "";
  for (const pos of equipmentPositions) {
    const desc = getText("Description", pos);
    if (desc.toLowerCase().includes("getriebe")) {
      transmission = desc;
      break;
    }
  }
  
  // VIN
  const vin = getText("VehicleIdentNumber");
  
  // KBA Code (HSN/TSN)
  const kbaCode = getText("KbaCode");
  
  // Kennzeichen
  const licensePlate = getText("LicenseNumber");
  
  // Ausstattungsliste extrahieren
  const features = [];
  const seenFeatures = new Set();
  
  for (const pos of equipmentPositions) {
    const desc = getText("Description", pos);
    if (desc && !seenFeatures.has(desc.toLowerCase())) {
      // Filtere Motor und Getriebe raus (haben wir schon)
      if (!desc.toLowerCase().includes("motor") && !desc.toLowerCase().includes("getriebe")) {
        features.push(desc);
        seenFeatures.add(desc.toLowerCase());
      }
    }
  }
  
  // Fahrzeugtyp bestimmen
  let vehicleType = "Gebrauchtwagen";
  const baseModelName = getText("BaseModelName").toLowerCase();
  if (baseModelName.includes("variant") || baseModelName.includes("kombi") || baseModelName.includes("touring")) {
    vehicleType = "Kombi";
  } else if (baseModelName.includes("suv") || baseModelName.includes("crossover")) {
    vehicleType = "SUV";
  } else if (baseModelName.includes("cabrio") || baseModelName.includes("roadster")) {
    vehicleType = "Cabrio";
  } else if (baseModelName.includes("coupe") || baseModelName.includes("coupé")) {
    vehicleType = "Coupé";
  }

  return {
    brand,
    model,
    year,
    mileage: mileage ? parseInt(mileage, 10) : 0,
    color,
    engine,
    power,
    fuel: fuel || "Benzin",
    transmission,
    vin,
    kbaCode,
    licensePlate,
    features: features.slice(0, 30), // Maximal 30 Features
    vehicleType,
    boersentyp: "Gebrauchtfahrzeug",
    // Zusätzliche Felder für das Formular
    description: `${brand} ${model}${year ? ` (${year})` : ""}${color ? `, ${color}` : ""}${power ? `, ${power}` : ""}`,
  };
};

export default parseVehicleXML;
